import {parseQueryString} from '@s-ui/js/lib/string'

import AdsMappersFactory from '../../ads/Mappers/factory.js'
import DealerMappersFactory from '../../dealer/Mappers/factory.js'
import {VehiclesMappersFactory} from '../../vehicles/Mappers/factory.js'
import {SearchErrorsFactory} from '../Errors/factory.js'
import {SearchValueObjectsFactory} from '../ValueObjects/factory.js'
import {FromSearchJSONToUrlVOProxyMapper} from './FromSearchJSONToUrlVOProxyMapper.js'
import {FromSearchParamsToRequestVOMapper} from './FromSearchParamsToRequestVOMapper.js'
import {FromSearchRequestVOToSubscriptionSearchRequestVOMapper} from './FromSearchRequestVOToSubscriptionSearchRequestVOMapper.js'
import {FromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper} from './FromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper.js'
import {FromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper} from './FromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper.js'
import {FromSubscriptionUrlVOToSearchRequestVOMapper} from './FromSubscriptionUrlVOToSearchRequestVOMapper.js'
import {NavigationDataVOToNavigationLinksVOMapper} from './NavigationDataVOToNavigationLinksVOMapper.js'

export class SearchMappersFactory {
  /**
   * @param {Object} deps
   * @return {FromSearchJSONToUrlVOProxyMapper}
   */
  static fromSearchJSONToUrlVOProxyMapper = ({config}) =>
    new FromSearchJSONToUrlVOProxyMapper({
      config,
      fromSearchJSONToUrlVOMapper: AdsMappersFactory.fromSearchJSONToUrlVOMapper({config}),
      fromVehicleSearchJSONtoUrlVOMapper: VehiclesMappersFactory.fromVehicleSearchJSONtoUrlVOMapper({config}),
      fromDealersListJSONtoUrlVOMapper: DealerMappersFactory.fromDealersListJSONtoUrlVOMapper({config}),

      invalidContextSearchError: SearchErrorsFactory.invalidContextSearchError
    })

  static fromSearchParamsToRequestVOMapper = ({config}) =>
    new FromSearchParamsToRequestVOMapper({
      config,
      searchRequestValueObject: SearchValueObjectsFactory.searchRequestValueObject
    })

  static fromSearchRequestVOToSubscriptionSearchRequestVOMapper = ({config}) =>
    new FromSearchRequestVOToSubscriptionSearchRequestVOMapper({
      config,
      subscriptionSearchRequestValueObjectFactory: SearchValueObjectsFactory.subscriptionSearchRequestValueObject
    })

  static fromSubscriptionUrlVOToSearchRequestVOMapper = ({config}) =>
    new FromSubscriptionUrlVOToSearchRequestVOMapper({
      config,
      parseQueryString,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static fromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper = ({config}) =>
    new FromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper({
      config,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static fromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper = ({config}) =>
    new FromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper({
      config,
      subscriptionSearchRequestValueObjectFactory: SearchValueObjectsFactory.subscriptionSearchRequestValueObject
    })

  static navigationDataVOToNavigationLinksVOMapper = ({config}) =>
    new NavigationDataVOToNavigationLinksVOMapper({
      config,
      navigationLinksValueObjectFactory: SearchValueObjectsFactory.navigationLinksValueObject
    })
}
